import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)] min-h-screen" }
const _hoisted_2 = { class: "w-full fixed z-40" }
const _hoisted_3 = {
  key: 0,
  class: "group fixed z-50 left-1/2 -translate-x-1/2 bottom-2 flex items-center justify-between py-1 pl-2 pr-1 w-11/12 max-w-sm bg-[#202F41] rounded-full border border-[#0A77F3] shadow-[0_0_3px_3px_rgba(10,119,243,0.5)] md:left-1/2 md:-translate-x-1/2 md:top-[20px] md:bottom-auto md:max-w-3xl"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "flex-1 flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "bg-[var(--bg)] group"
}
const _hoisted_7 = { class: "container text-center mx-auto px-12 sm:px-24" }
const _hoisted_8 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_16 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_17 = ["src"]

import {
  defineAsyncComponent,
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { HelloDigi } from '@digi-io/digi-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));

const { VUE_APP_DIGI_USERS_F } = process.env;

const store = useStore();
const route = useRoute();

const showSidebar = computed(() => store.state.sidebar);
const isAppRoute = computed(() => route.path.startsWith('/app'));
const isLight = computed(() => store.state.theme?.theme === 'light');

const showAd = ref(localStorage.getItem('hideSkyAd') !== 'true');
const digiSystemslink = ref<string>(VUE_APP_DIGI_USERS_F);

const closeAd = () => {
  showAd.value = false;
  localStorage.setItem('hideSkyAd', 'true');
};

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

function toggleSidebar() {
  store.commit('toggleSidebar');
}

onMounted(() => {
  const timer = setTimeout(() => {
    if (localStorage.getItem('hideSkyAd') !== 'true') {
      showAd.value = true;
    }
  }, 2500);

  onBeforeUnmount(() => clearTimeout(timer));
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Notifications)),
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_unref(NavBar)),
      _createVNode(_unref(Sidebar))
    ])), [
      [_directive_click_outside, clickOutside]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["h-screen overflow-y-auto pt-12 relative", { 'blocker': showSidebar.value }])
    }, [
      _createVNode(_Transition, {
        name: "ad",
        appear: ""
      }, {
        default: _withCtx(() => [
          (showAd.value && isAppRoute.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  src: "/img/logo-sky-light.svg",
                  alt: "sky Logo",
                  class: "h-4 sm:h-5"
                }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-[var(--text)] font-light text-xs mx-0 sm:text-sm sm:mx-8" }, [
                  _createTextVNode(" keep your files safe, synced, and ready anytime. "),
                  _createElementVNode("span", { class: "font-semibold ml-2 text-md hidden sm:inline" }, " Beyond space. Beyond limits")
                ], -1)),
                _createElementVNode("a", {
                  href: `${digiSystemslink.value}/app/redirect?app=sky`,
                  onClick: closeAd,
                  target: "_blank",
                  class: "inline-flex items-center gap-1 border border-[#0A77F3] bg-[#0A77F3] rounded-full px-1 py-1 text-white text-xs font-regular hover:bg-[#0A77F3] hover:shadow-[0_0_3px_3px_rgba(10,119,243,0.5)] transition-all duration-300 ease-in-out sm:px-3 sm:py-1 cursor-pointer"
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "mr-1 sm:block hidden" }, "Try it now", -1),
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    class: "w-4 h-4 transition-all duration-150 arrow-move"
                  }, [
                    _createElementVNode("g", { mask: "url(#mask0_1358_7)" }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M5.65005 10.0251L7.60005 10.8501C7.83338 10.3834 8.07505 9.93344 8.32505\n                        9.50011C8.57505 9.06677 8.85005 8.63344 9.15005 8.20011L7.75005\n                        7.92511L5.65005 10.0251ZM9.20005 12.1001L12.05 14.9251C12.75\n                        14.6584 13.5 14.2501 14.3 13.7001C15.1 13.1501 15.85 12.5251\n                        16.55 11.8251C17.7167 10.6584 18.6292 9.36261 19.2875 7.93761C19.9459\n                        6.51261 20.2334 5.20011 20.15 4.00011C18.95 3.91677 17.6334 4.20427\n                        16.2 4.86261C14.7667 5.52094 13.4667 6.43344 12.3 7.60011C11.6 8.30011\n                        10.975 9.05011 10.425 9.85011C9.87505 10.6501 9.46672 11.4001 9.20005\n                        12.1001ZM13.65 10.4751C13.2667 10.0918 13.075 9.62094 13.075 9.06261C13.075\n                        8.50427 13.2667 8.03344 13.65 7.65011C14.0334 7.26677 14.5084 7.07511 15.075\n                        7.07511C15.6417 7.07511 16.1167 7.26677 16.5 7.65011C16.8834 8.03344\n                        17.075 8.50427 17.075 9.06261C17.075 9.62094 16.8834 10.0918 16.5\n                        10.4751C16.1167 10.8584 15.6417 11.0501 15.075 11.0501C14.5084\n                          11.0501 14.0334 10.8584 13.65 10.4751ZM14.125 18.5001L16.225\n                          16.4001L15.95 15.0001C15.5167 15.3001 15.0834 15.5709 14.65\n                          15.8126C14.2167 16.0543 13.7667 16.2918 13.3 16.5251L14.125\n                          18.5001ZM21.95 2.17511C22.2667 4.19177 22.0709 6.15427 21.3625\n                          8.06261C20.6542 9.97094 19.4334 11.7918 17.7 13.5251L18.2 16.0001C18.2667\n                          16.3334 18.25 16.6584 18.15 16.9751C18.05 17.2918 17.8834 17.5668\n                          17.65 17.8001L13.45 22.0001L11.35 17.0751L7.07505 12.8001L2.15005\n                          10.7001L6.32505 6.50011C6.55838 6.26677 6.83755 6.10011 7.16255\n                          6.00011C7.48755 5.90011 7.81672 5.88344 8.15005 5.95011L10.625\n                          6.45011C12.3584 4.71677 14.175 3.49177 16.075 2.77511C17.975\n                          2.05844 19.9334 1.85844 21.95 2.17511ZM3.92505 15.9751C4.50838\n                          15.3918 5.22088 15.0959 6.06255 15.0876C6.90422 15.0793 7.61672\n                          15.3668 8.20005 15.9501C8.78338 16.5334 9.07088 17.2459 9.06255\n                          18.0876C9.05422 18.9293 8.75838 19.6418 8.17505 20.2251C7.75838\n                          20.6418 7.06255 21.0001 6.08755 21.3001C5.11255 21.6001 3.76672\n                          21.8668 2.05005 22.1001C2.28338 20.3834 2.55005 19.0376 2.85005\n                          18.0626C3.15005 17.0876 3.50838 16.3918 3.92505 15.9751ZM5.35005\n                          17.3751C5.18338 17.5418 5.01672 17.8459 4.85005 18.2876C4.68338\n                          18.7293 4.56672 19.1751 4.50005 19.6251C4.95005 19.5584 5.39588\n                          19.4459 5.83755 19.2876C6.27922 19.1293 6.58338 18.9668 6.75005\n                          18.8001C6.95005 18.6001 7.05838 18.3584 7.07505 18.0751C7.09172\n                          17.7918 7.00005 17.5501 6.80005 17.3501C6.60005 17.1501 6.35838\n                          17.0543 6.07505 17.0626C5.79172 17.0709 5.55005 17.1751 5.35005\n                  17.3751Z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)
                ]))], 8, _hoisted_4),
                _createElementVNode("button", {
                  onClick: closeAd,
                  class: "absolute -right-3 -top-1.5 text-white text-xs opacity-10 group-hover:opacity-70 transition-all duration-300 ease-in-out"
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view, { class: "flex-1 min-h-[calc(102vh-5rem)]" })
      ]),
      (!isAppRoute.value)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: `${_ctx.usersLink}`,
                  target: "_blank",
                  class: "mb-10 sm:mb-0"
                }, [
                  _createElementVNode("img", {
                    src: isLight.value
                ? '/img/logo-digi-light.svg'
                : '/img/logo-digi.svg',
                    alt: "Logo",
                    class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                  }, null, 8, _hoisted_10)
                ], 8, _hoisted_9),
                _createElementVNode("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"text-left\" data-v-32544458><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-32544458>Products</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-32544458><li data-v-32544458><a href=\"#\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-32544458>Sky </a></li><li data-v-32544458><a href=\"#\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-32544458>Fireweb </a></li><li data-v-32544458><a href=\"#\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-32544458>DigiCare </a></li></ul></div><div class=\"text-left\" data-v-32544458><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-32544458>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-32544458><li data-v-32544458><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-32544458>Help Center </a></li><li data-v-32544458><a href=\"https://discord.gg/UsGXbTkJSE\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-32544458>Discord </a></li></ul></div>", 2)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Legal", -1)),
                    _createElementVNode("ul", _hoisted_13, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: `${digiSystemslink.value}/privacy-policy`,
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, "Privacy Policy ", 8, _hoisted_14)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, "© " + _toDisplayString(_ctx.currentYear) + " digi systems All rights reserved. ", 1),
                _createElementVNode("button", {
                  onClick: toggleTheme,
                  class: "rounded-full"
                }, [
                  _createElementVNode("img", {
                    src: isLight.value
                ? '/img/icon/icon-light.svg'
                : '/img/icon/icon-dark.svg',
                    alt: "theme toggle",
                    class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                  }, null, 8, _hoisted_17)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})